import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { makeSimpleDigitalSensorElement } from "./simpleDigitalSensorElements.js";
import { SensorElementConfig } from "./types.js";

const unityIdentity = {
    conversionKey: "unity" as const,
    parameterConfigs: {} as Record<string, never>,
    buildConversionParams: () => ({}) as Record<string, never>,
} as const;

export const zoneNdviElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    ...unityIdentity,
    legalConvertedRange: [-1, 1],
    decodedUnits: "ndvi",
    convertedUnits: "ndvi",
    unitCategory: "ndvi",
    testCases: [{ parameters: {}, decodedValue: 0.6, convertedValue: 0.6 }],
} as const;

export const zoneNdviVarianceElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.unity
> = {
    ...unityIdentity,
    legalConvertedRange: [0, null],
    decodedUnits: "ndvi",
    convertedUnits: "ndvi",
    unitCategory: "ndviVariance",
    testCases: [{ parameters: {}, decodedValue: 0.05, convertedValue: 0.05 }],
} as const;

export const zoneIrrigationScheduledElementConfig = makeSimpleDigitalSensorElement("code", 1);
